/**
 * Product Card Slider — infinite swipe 3 images
 * Ref: ladypipa.com/collections/bestsellers
 */
(function() {
  function initCardSliders() {
    document.querySelectorAll('[data-card-slider]').forEach(function(slider) {
      if (slider.dataset.sliderInit) return;
      slider.dataset.sliderInit = 'true';

      var slides = slider.querySelectorAll('.product-card__slide');
      if (slides.length < 2) return;

      var realCount = slides.length;

      // Clone first and last for infinite loop
      var firstClone = slides[0].cloneNode(true);
      var lastClone = slides[slides.length - 1].cloneNode(true);
      firstClone.classList.add('product-card__slide--clone');
      lastClone.classList.add('product-card__slide--clone');
      slider.appendChild(firstClone);
      slider.insertBefore(lastClone, slides[0]);

      var allSlides = slider.querySelectorAll('.product-card__slide');
      var firstRealSlide = allSlides[1];
      var lastRealSlide = allSlides[realCount];
      var currentRealIndex = 0;

      function getSlideWidth() {
        return firstRealSlide ? firstRealSlide.getBoundingClientRect().width : slider.getBoundingClientRect().width;
      }

      function getSlideStart(slide) {
        var sliderRect = slider.getBoundingClientRect();
        var slideRect = slide.getBoundingClientRect();
        return slider.scrollLeft + slideRect.left - sliderRect.left;
      }

      function jumpToSlide(slide) {
        if (!slide) return;
        slider.style.scrollBehavior = 'auto';
        slider.scrollLeft = Math.ceil(getSlideStart(slide));
        slider.style.scrollBehavior = '';
      }

      function alignCurrentSlide() {
        allSlides = slider.querySelectorAll('.product-card__slide');
        firstRealSlide = allSlides[1];
        lastRealSlide = allSlides[realCount];
        jumpToSlide(allSlides[currentRealIndex + 1] || firstRealSlide);
      }

      // Start at real first slide (index 1 because of prepended clone).
      requestAnimationFrame(function() {
        alignCurrentSlide();
        requestAnimationFrame(alignCurrentSlide);
      });

      var scrollTimeout;
      slider.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
          var slideWidth = getSlideWidth();
          var scrollLeft = slider.scrollLeft;
          if (!slideWidth) return;

          var index = Math.round(scrollLeft / slideWidth);
          var maxIndex = realCount + 1; // realCount + 2 clones, 0-indexed

          // Jump to real slide if on a clone
          if (index <= 0) {
            currentRealIndex = realCount - 1;
            jumpToSlide(lastRealSlide);
            index = realCount;
          } else if (index >= maxIndex) {
            currentRealIndex = 0;
            jumpToSlide(firstRealSlide);
            index = 1;
          } else {
            currentRealIndex = index - 1;
          }

        }, 80);
      }, { passive: true });

      var resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          requestAnimationFrame(alignCurrentSlide);
        }, 120);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardSliders);
  } else {
    initCardSliders();
  }

  if (typeof window.setupCollectionHandlers === 'function') {
    var _orig = window.setupCollectionHandlers;
    window.setupCollectionHandlers = function() {
      _orig();
      initCardSliders();
    };
  }

  window.initCardSliders = initCardSliders;
})();
